import React from 'react';

const metricDefs = [
  { key: 'tenYearYield', label: '10-Year Treasury', suffix: '%', description: 'Benchmark long-term rate' },
  { key: 'twoYearYield', label: '2-Year Treasury', suffix: '%', description: 'Benchmark short-term rate' },
  { key: 'spreadTwoTen', label: '2s/10s Spread', suffix: '%', description: 'Positive = normal, Negative = inverted', isCurve: true },
  { key: 'fedFundsRate', label: 'Fed Funds Rate', suffix: '', description: 'Federal Reserve target range / midpoint' },
  { key: 'igSpread', label: 'IG Credit Spread', suffix: ' bps', description: 'Investment-grade bond spread' },
  { key: 'hySpread', label: 'HY Credit Spread', suffix: ' bps', description: 'High-yield (junk) bond spread' },
  { key: 'moveIndex', label: 'MOVE Index', suffix: '', description: 'Bond market volatility' },
  { key: 'vix', label: 'VIX', suffix: '', description: 'Stock market volatility' },
];

function statusIsFallback(status = '') {
  const text = String(status).toLowerCase();
  return text.includes('backup') || text.includes('fallback') || text.includes('baseline') || text.includes('estimated');
}

function getMetricColor(key, value) {
  switch (key) {
    case 'spreadTwoTen':
      if (value > 0.2) return '#22c55e';
      if (value > 0) return '#eab308';
      return '#ef4444';
    case 'igSpread':
      if (value < 120) return '#22c55e';
      if (value < 180) return '#eab308';
      return '#ef4444';
    case 'hySpread':
      if (value < 380) return '#22c55e';
      if (value < 550) return '#eab308';
      return '#ef4444';
    case 'moveIndex':
      if (value < 100) return '#22c55e';
      if (value < 130) return '#eab308';
      return '#ef4444';
    case 'vix':
      if (value < 18) return '#22c55e';
      if (value < 25) return '#eab308';
      return '#ef4444';
    default:
      return '#3b82f6';
  }
}

export default function KeyMetrics({ metrics, isLive = false }) {
  if (!metrics) return null;

  return (
    <div className="animate-slide-up" style={{ animationDelay: '0.3s' }}>
      <h3 className="font-display font-bold text-lg text-mentor-text mb-4">
        Key Market Metrics
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {metricDefs.map((def) => {
          const value = metrics[def.key];
          const status = metrics?._statuses?.[def.key] || '';
          const numericValue = Number(value);
          const zeroCanBeValid = def.key === 'spreadTwoTen';
          const hasValue = value !== undefined
            && value !== null
            && value !== ''
            && !(Number.isFinite(numericValue) && numericValue === 0 && !zeroCanBeValid);
          const color = hasValue && Number.isFinite(numericValue) ? getMetricColor(def.key, numericValue) : '#94a3b8';
          const fallback = statusIsFallback(status);

          return (
            <div key={def.key} className={`stat-card ${fallback ? 'border-signal-yellow/25 bg-signal-yellow/5' : ''}`}>
              <p className="text-xs text-mentor-muted font-body mb-1 uppercase tracking-wider">
                {def.label}
              </p>
              <p className="font-mono text-xl font-bold" style={{ color }}>
                {!hasValue ? 'N/A' : (def.isCurve && numericValue > 0 ? '+' : '')}
                {hasValue ? (typeof value === 'number' ? value.toFixed(def.key === 'igSpread' || def.key === 'hySpread' ? 0 : 2) : value) : ''}
                {hasValue && <span className="text-sm font-normal text-mentor-muted">{def.suffix}</span>}
              </p>
              <p className="text-xs text-mentor-muted mt-1 font-body">
                {isLive && status ? status : (isLive && !hasValue ? 'Unavailable — no trusted backup value' : def.description)}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
